import { fromJS, Map } from 'immutable';

export function request(state, data) {
    let collections = state.get('collections');
    if (data.data.page > 1) {
        collections = collections.setIn([ data.id, 'state' ], 'IN_PROGRESS');
    } else {
        collections = collections.set(data.id, fromJS({
            state: 'IN_PROGRESS',
            items: []
        }));
    }
    return state.set('collections', collections);
}

export function error(state, data) {
    let collections = state.get('collections');

    collections = collections.set(data.id, fromJS({
        state: 'ERROR',
        errors: data.errors,
        items: []
    }));

    return state.set('collections', collections);
}

export function finish(state, data) {
    let collections = state.get('collections');
    const audits = data.audits.results && data.audits.results.map((audit) => audit);
    if (data.query.page > 1) {
       collections = collections.set(data.id, fromJS({
          state: 'FINISHED',
          items: collections.getIn([ data.id, 'items' ]).concat(fromJS(audits)),
          aggregations: data.audits.aggregations,
          query: data.query
      }));
    } else {
      collections = collections.set(data.id, fromJS({
          state: 'FINISHED',
          items: audits,
          aggregations: data.audits.aggregations,
          query: data.query
      }));
    }

    return state.set('collections', collections);
}
